var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
import { Clipboard } from 'ionic-native';
import { ToastController, Platform, AlertController } from 'ionic-angular';
export var NeighborhoodTag = (function () {
    function NeighborhoodTag(alertCtrl, toastCtrl, platform) {
        this.alertCtrl = alertCtrl;
        this.toastCtrl = toastCtrl;
        this.platform = platform;
    }
    NeighborhoodTag.prototype.ngOnChanges = function (changes) {
        if (!this.tag.startsWith('#')) {
            this.hashedTag = '#' + this.tag;
        }
        else {
            this.hashedTag = this.tag;
        }
    };
    NeighborhoodTag.prototype.copyTag = function () {
        if (this.platform.is('cordova') && this.platform.is('android')) {
            this.showToast();
            Clipboard.copy(this.hashedTag);
        }
        else {
            this.showAlert();
        }
    };
    NeighborhoodTag.prototype.showAlert = function () {
        var message;
        if (this.name) {
            message = this.name + "<br/>Tag: " + this.hashedTag;
        }
        else {
            message = "Tag: " + this.hashedTag;
        }
        var detailsAlert = this.alertCtrl.create({
            title: "Neighborhood Details",
            message: message,
            buttons: ['OK']
        });
        detailsAlert.present();
    };
    NeighborhoodTag.prototype.showToast = function () {
        var tagToast = this.toastCtrl.create({
            message: "Neighborhood tag " + this.hashedTag + " copied to clipboard.",
            duration: 3000
        });
        tagToast.present();
    };
    __decorate([
        Input("tag"), 
        __metadata('design:type', String)
    ], NeighborhoodTag.prototype, "tag", void 0);
    __decorate([
        Input("name"), 
        __metadata('design:type', String)
    ], NeighborhoodTag.prototype, "name", void 0);
    NeighborhoodTag = __decorate([
        Component({
            selector: 'neighborhood-tag',
            template: '<a (click)="copyTag()">{{name || tag}}</a>'
        }), 
        __metadata('design:paramtypes', [AlertController, ToastController, Platform])
    ], NeighborhoodTag);
    return NeighborhoodTag;
}());
